// extracted by mini-css-extract-plugin
export default {"chunks":"article_chunks__3MoKi","selectable":"article_selectable__6gwdj","selected":"article_selected__PGgKw","active":"article_active__UA6KF"};